import React from 'react';

if (process.env.NODE_ENV === 'development' && false) {
  console.log('we should be tracking with WDYR');
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
    logOnDifferentValues: true,
  });
}
